module.exports = __webpack_public_path__ + "img/smiley_negative_ico.9584c0b2.png";